// src/components/Journal.js
import React, { useEffect, useState } from "react";
import file from "../assets/file.docx";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const Journal = ({ language }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("news");
  const [news, setNews] = useState([]);
  const [publications, setPublications] = useState([]);
  const [media, setMedia] = useState([]);
  // Add at the top of your component
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const content = {
    news: [
      {
        title: {
          en: "Arma Academy Launches New Technical Training Program",
          ar: "أكاديمية آرما تطلق برنامج تدريبي فني جديد",
        },
        date: "2024-01-15",
        excerpt: {
          en: "The academy announces the launch of its latest technical training program focused on modern maintenance techniques.",
          ar: "تعلن الأكاديمية عن إطلاق أحدث برامجها التدريبية الفنية الذي يركز على تقنيات الصيانة الحديثة.",
        },
      },
      {
        title: {
          en: "Partnership with International Training Organizations",
          ar: "شراكة مع منظمات تدريبية دولية",
        },
        date: "2024-01-10",
        excerpt: {
          en: "Arma Academy signs cooperation agreements with leading international training institutions.",
          ar: "أكاديمية آرما توقع اتفاقيات تعاون مع مؤسسات تدريبية دولية رائدة.",
        },
      },
    ],
    publications: [
      {
        title: {
          en: "Business management",
          ar: "ادارة الاعمال",
        },
        author: { en: "Formation OBS", ar: "شركة فورميشن" },
        year: "2023",
      },
      {
        title: {
          en: "Modern Approaches to Employee Development",
          ar: "مناهج حديثة في تطوير الموظفين",
        },
        author: { en: "Prof. Fatima Hassan", ar: "أ. فاطمة حسن" },
        year: "2023",
      },
    ],
    media: [
      {
        title: {
          en: "Virtual Tour of Arma Academy Facilities",
          ar: "جولة افتراضية في مرافق أكاديمية آرما",
        },
        type: "video",
      },
      {
        title: {
          en: "Photo Gallery: 2023 Graduation Ceremony",
          ar: "معرض الصور: حفل التخرج 2023",
        },
        type: "gallery",
      },
    ],
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BASE_URL + "news/get-all-news")
      .then((res) => setNews(res.data.data));

    axios
      .get(process.env.REACT_APP_BASE_URL + "publication/get-all-publications")
      .then((res) => setPublications(res.data.data));

    axios
      .get(process.env.REACT_APP_BASE_URL + "media/get-all-media")
      .then((res) => setMedia(res.data.data));
  }, []);

  return (
    <section id="journal" className="py-16 bg-green-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4">
            {language === "ar" ? "مجلة الاكاديمية" : "Academy Journal"}
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            {language === "ar"
              ? "أحدث الأخبار والإصدارات والوسائط المتعددة من أكاديمية آرما"
              : "Latest news, publications, and multimedia from Arma Academy"}
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-8">
          <div className="bg-white rounded-lg p-1 shadow-sm">
            {[
              { key: "news", label: { en: "News", ar: "الأخبار" } },
              {
                key: "publications",
                label: { en: "Publications", ar: "الإصدارات" },
              },
              { key: "media", label: { en: "Media", ar: "الوسائط" } },
            ].map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-6 py-2 rounded-md font-medium transition-colors ${
                  activeTab === tab.key
                    ? "bg-green-600 text-white"
                    : "text-gray-600 hover:text-green-700"
                }`}
              >
                {tab.label[language]}
              </button>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="mx-auto">
          {activeTab === "news" && (
            <div className="space-y-6">
              {news.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
                >
                  <h3 className="text-xl font-bold text-green-900 mb-2">
                    {language === "ar" ? item.title_ar : item.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-3">
                    {moment(item.date).format("YYYY-MM-DD")}
                  </p>
                  <p className="text-gray-700 truncate">
                    {language === "ar" ? item.body_ar : item.body}
                  </p>
                  <button
                    onClick={() =>
                      navigate(`/news/${item.id}`, {
                        state: {
                          newsItem: item,
                          language: language, // You can also pass language
                        },
                      })
                    }
                    className="mt-4 text-green-600 font-semibold hover:text-green-700 transition-colors cursor-pointer"
                  >
                    {language === "ar" ? "اقرأ المزيد" : "Read More"} →
                  </button>
                </div>
              ))}
            </div>
          )}

          {activeTab === "publications" && (
            <div className="grid md:grid-cols-2 gap-6">
              {publications.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
                >
                  <h3 className="text-lg font-bold text-green-900 mb-2">
                    {language === "ar" ? item.title_ar : item.title}
                  </h3>
                  <p className="text-gray-600 mb-1">
                    {language === "ar" ? "المؤلف:" : "Author:"}{" "}
                    {language === "ar" ? item.author_ar : item.author}
                  </p>
                  <p className="text-gray-600">
                    {language === "ar" ? "السنة:" : "Year:"} {item.year}
                  </p>
                  <a
                    href={process.env.REACT_APP_BASE_URL + item.file}
                    target="_blank"
                    download
                    className="mt-4 inline-block text-green-600 font-semibold hover:text-green-700 transition-colors"
                  >
                    {language === "ar" ? "تحميل البحث" : "Download Research"} ↓
                  </a>
                </div>
              ))}
            </div>
          )}

          {/* {activeTab === "media" && (
            <div className="grid md:grid-cols-2 gap-6">
              {media.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                >
                  <div className="h-48 bg-gradient-to-r from-green-400 to-green-600 flex items-center justify-center">
                    {item.type === "Video" ? (
                      <svg
                        className="w-16 h-16 text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : (
                      <img src={process.env.REACT_APP_BASE_URL + item.file} />
                    )}
                  </div>
                  <div className="p-4">
                    <h3 className="font-bold text-green-900">{item.title}</h3>
                    <button className="mt-2 text-green-600 font-semibold hover:text-green-700 transition-colors">
                      {language === "ar" ? "عرض" : "View"} →
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )} */}
          {activeTab === "media" && (
            <>
              <div className="grid md:grid-cols-4 gap-6 w-full">
                {media.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                    onClick={() => {
                      setSelectedMedia(item);
                      setIsModalOpen(true);
                    }}
                  >
                    <div className="h-48 bg-gray-100 overflow-hidden">
                      {item.type === "Video" ? (
                        <video
                          src={process.env.REACT_APP_BASE_URL + item.file}
                          className="w-full h-full object-cover"
                          preload="metadata"
                        />
                      ) : (
                        <img
                          src={process.env.REACT_APP_BASE_URL + item.file}
                          alt={item.title}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      )}
                    </div>
                    <div className="p-4">
                      <h3 className="font-bold text-green-900">{item.title}</h3>
                    </div>
                  </div>
                ))}
              </div>

              {/* Modal for media preview */}
              {isModalOpen && selectedMedia && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4"
                  onClick={() => setIsModalOpen(false)}
                >
                  <div
                    className="relative max-w-7xl w-full max-h-[90vh]"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* Close button */}
                    <button
                      className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 z-10"
                      onClick={() => setIsModalOpen(false)}
                    >
                      ✕
                    </button>

                    {/* Media content */}
                    <div className="bg-black rounded-lg overflow-hidden">
                      {selectedMedia.type === "Video" ? (
                        <video
                          src={
                            process.env.REACT_APP_BASE_URL + selectedMedia.file
                          }
                          className="w-full h-auto max-h-[80vh]"
                          controls
                          autoPlay
                        />
                      ) : (
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL + selectedMedia.file
                          }
                          alt={selectedMedia.title}
                          className="w-full h-auto max-h-[80vh] object-contain"
                        />
                      )}
                    </div>

                    {/* Caption */}
                    <div className="mt-4 text-center">
                      <h3 className="text-xl font-semibold text-white">
                        {selectedMedia.title}
                      </h3>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Journal;
